import { EntityProfileTabUpdatesList } from './EntityProfileTabUpdatesList'

import * as styles from './EntityProfileTabUpdates.module.css'

function EntityProfileTabUpdates({
  deletedOwnerNameKey = 'EntityProfileTabUpdates.DeletedOwnerNameKey',
  emptyStateTextKey = 'EntityProfileTabUpdates.EmptyStateTextKey',
  errorStateTextKey = 'EntityProfileTabUpdates.ErrorStateTextKey',
  getThresholdItemProps,
  hasError,
  isLoading,
  isLoadingMore,
  items,
  systemOwnerNameKey = 'EntityProfileTabUpdates.SystemOwnerNameKey',
}) {
  return (
    <div className={styles.container}>
      <EntityProfileTabUpdatesList
        deletedOwnerNameKey={deletedOwnerNameKey}
        emptyStateTextKey={emptyStateTextKey}
        errorStateTextKey={errorStateTextKey}
        getThresholdItemProps={getThresholdItemProps}
        hasError={hasError}
        isLoading={isLoading}
        isLoadingMore={isLoadingMore}
        items={items}
        systemOwnerNameKey={systemOwnerNameKey}
      />
    </div>
  )
}

export default EntityProfileTabUpdates
